export default function buildPostShopChat({
    apiEndpoint,
    apiTools
}) {
    return async function postShopChat(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/shop` 
        })
       
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            credentials: 'include',
        });
        return await res.json();
    }
}